import { IconFileTypePdf } from '@tabler/icons-react'
import { FC, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import styles from '../../styles/admin/StudyContent.module.scss'

interface PdfDropzoneProps {
  pdfFile: File | null
  onPdfChange: (file: File | null) => void
  existingPdfUrl?: string
  iconSize?: number
  className?: string
  placeholderText?: string
  label?: string
  showLabel?: boolean
}

const PdfDropzone: FC<PdfDropzoneProps> = ({
  pdfFile,
  onPdfChange,
  existingPdfUrl,
  iconSize = 48,
  className,
  placeholderText = 'Drag & Drop or Click to Upload PDF',
  label = 'PDF 파일',
  showLabel = false,
}) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0]
        if (file.type === 'application/pdf') {
          onPdfChange(file)
        }
      }
    },
    [onPdfChange]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
    },
    multiple: false,
    maxSize: 50 * 1024 * 1024, // 10MB
  })

  return (
    <div className={styles.imageDropzoneContainer2}>
      <div className={styles.imageDropzoneWrapper2}>
        {showLabel && (
          <span
            style={{
              fontSize: '15px',
              fontWeight: 700,
              color: '#111',
            }}
          >
            {label}
          </span>
        )}
        <div style={{ marginBottom: '12px' }}></div>
        <div
          {...getRootProps()}
          className={`${className || styles.imageDropzone} ${isDragActive ? styles.dragActive : ''}`}
        >
          <input {...getInputProps()} />
          {pdfFile ? (
            <div className={styles.pdfPreview}>
              <IconFileTypePdf size={iconSize} color="#0d2a4f" />
              <p>{pdfFile.name}</p>
              <span>{(pdfFile.size / 1024 / 1024).toFixed(2)} MB</span>
            </div>
          ) : existingPdfUrl ? (
            <div className={styles.existingPdf}>
              <IconFileTypePdf size={iconSize} color="#0d2a4f" />
              <p>기존 PDF 파일</p>
              <a
                href={existingPdfUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                파일 보기
              </a>
            </div>
          ) : (
            <div className={styles.uploadPlaceholder}>
              <IconFileTypePdf size={iconSize} color="#0d2a4f" />
              <p>
                {isDragActive ? 'Drop the PDF file here...' : placeholderText}
              </p>
              <span>PDF (50MB)</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PdfDropzone
